"use strict";

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XXFallbackHandshake = void 0;

var buffer_1 = require("buffer");

var handshake_xx_1 = require("./handshake-xx");

var utils_1 = require("./utils");

var logger_1 = require("./logger");

var encoder_1 = require("./encoder");

var XXFallbackHandshake = /*#__PURE__*/function (_handshake_xx_1$XXHan) {
  _inherits(XXFallbackHandshake, _handshake_xx_1$XXHan);

  var _super = _createSuper(XXFallbackHandshake);

  function XXFallbackHandshake(isInitiator, payload, prologue, staticKeypair, connection, initialMsg, remotePeer, ephemeralKeys, handshake) {
    var _this;

    _classCallCheck(this, XXFallbackHandshake);

    _this = _super.call(this, isInitiator, payload, prologue, staticKeypair, connection, remotePeer, handshake);

    if (ephemeralKeys) {
      _this.ephemeralKeys = ephemeralKeys;
    }

    _this.initialMsg = initialMsg;
    return _this;
  } // stage 0
  // eslint-disable-next-line require-await


  _createClass(XXFallbackHandshake, [{
    key: "propose",
    value: function () {
      var _propose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var receivedMessageBuffer, _this$xx$recvMessage, valid;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isInitiator) {
                  _context.next = 6;
                  break;
                }

                this.xx.sendMessage(this.session, buffer_1.Buffer.alloc(0), this.ephemeralKeys);
                logger_1.logger('XX Fallback Stage 0 - Initialized state as the first message was sent by initiator.');
                logger_1.logLocalEphemeralKeys(this.session.hs.e);
                _context.next = 13;
                break;

              case 6:
                logger_1.logger('XX Fallback Stage 0 - Responder decoding initial msg from IK.');
                receivedMessageBuffer = encoder_1.decode0(this.initialMsg);
                _this$xx$recvMessage = this.xx.recvMessage(this.session, {
                  ne: receivedMessageBuffer.ne,
                  ns: buffer_1.Buffer.alloc(0),
                  ciphertext: buffer_1.Buffer.alloc(0)
                }), valid = _this$xx$recvMessage.valid;

                if (valid) {
                  _context.next = 11;
                  break;
                }

                throw new Error('xx fallback stage 0 decryption validation fail');

              case 11:
                logger_1.logger('XX Fallback Stage 0 - Responder used received message from IK.');
                logger_1.logRemoteEphemeralKey(this.session.hs.re);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function propose() {
        return _propose.apply(this, arguments);
      }

      return propose;
    }() // stage 1

  }, {
    key: "exchange",
    value: function () {
      var _exchange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var receivedMessageBuffer, _this$xx$recvMessage2, plaintext, valid, decodedPayload, err;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isInitiator) {
                  _context2.next = 31;
                  break;
                }

                receivedMessageBuffer = encoder_1.decode1(this.initialMsg);
                _this$xx$recvMessage2 = this.xx.recvMessage(this.session, receivedMessageBuffer), plaintext = _this$xx$recvMessage2.plaintext, valid = _this$xx$recvMessage2.valid;

                if (valid) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('xx fallback stage 1 decryption validation fail');

              case 5:
                logger_1.logger('XX Fallback Stage 1 - Initiator used received message from IK.');
                logger_1.logRemoteEphemeralKey(this.session.hs.re);
                logger_1.logRemoteStaticKey(this.session.hs.rs);
                logger_1.logger("Initiator going to check remote's signature...");
                _context2.prev = 9;
                _context2.next = 12;
                return utils_1.decodePayload(plaintext);

              case 12:
                decodedPayload = _context2.sent;
                _context2.t0 = this.remotePeer;

                if (_context2.t0) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 17;
                return utils_1.getPeerIdFromPayload(decodedPayload);

              case 17:
                _context2.t0 = _context2.sent;

              case 18:
                this.remotePeer = _context2.t0;
                _context2.next = 21;
                return utils_1.verifySignedPayload(this.session.hs.rs, decodedPayload, this.remotePeer);

              case 21:
                this.setRemoteEarlyData(decodedPayload.data);
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t1 = _context2["catch"](9);
                err = _context2.t1;
                throw new Error("Error occurred while verifying signed payload from responder: ".concat(err.message));

              case 28:
                logger_1.logger('All good with the signature!');
                _context2.next = 35;
                break;

              case 31:
                logger_1.logger('XX Fallback Stage 1 - Responder start');
                _context2.next = 34;
                return _get(_getPrototypeOf(XXFallbackHandshake.prototype), "exchange", this).call(this);

              case 34:
                logger_1.logger('XX Fallback Stage 1 - Responder end');

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 24]]);
      }));

      function exchange() {
        return _exchange.apply(this, arguments);
      }

      return exchange;
    }()
  }]);

  return XXFallbackHandshake;
}(handshake_xx_1.XXHandshake);

exports.XXFallbackHandshake = XXFallbackHandshake;